const TONES = ["--accent", "--success", "--warning", "--danger"] as const;

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("") || "?";

/** A small square with the first letters of a name, in a soft colour taken from the name, for rows that have no picture. */
export function InitialsTile({ name }: { name: string }) {
  const tone =
    TONES[
      Array.from(name).reduce((sum, char) => sum + char.charCodeAt(0), 0) %
        TONES.length
    ];

  return (
    <span
      aria-hidden="true"
      className="flex size-10 shrink-0 items-center justify-center rounded-xl text-sm font-semibold"
      style={{
        backgroundColor: `color-mix(in oklab, var(${tone}) 14%, transparent)`,
        color: `var(${tone})`,
      }}
    >
      {initialsOf(name)}
    </span>
  );
}
